/**
 * dsh-widgets — GENERATED widget registry. DO NOT EDIT BY HAND.
 *
 * Produced by scripts/gen-registry.mjs from the unit dirs under src/widgets/
 * (the machine-readable part comes from each unit's manifest.json; the
 * descriptors come from each unit's index.ts). Regenerate with:
 *   pnpm gen:registry        (write)
 *   pnpm check:registry      (verify up-to-date — the build/CI guard)
 *
 * Adding a widget = creating one unit dir; the registry follows automatically.
 */

import w_counts from '../widgets/counts'
import w_llm from '../widgets/llm'
import w_tool from '../widgets/tool'
import w_ttft from '../widgets/ttft'
import w_tps from '../widgets/tps'
import w_cache from '../widgets/cache'
import w_tokens from '../widgets/tokens'
import w_context from '../widgets/context'
import w_context_water from '../widgets/context-water'
import w_task from '../widgets/task'
import w_trajectory from '../widgets/trajectory'
import w_quote from '../widgets/quote'
import w_heatmap from '../widgets/heatmap'
import w_heatmap_bars from '../widgets/heatmap-bars'
import w_quota_manage from '../widgets/quota-manage'
import w_usage_bars from '../widgets/usage-bars'
import w_usage_rings from '../widgets/usage-rings'
import w_usage_rolling from '../widgets/usage-rolling'
import w_usage_weekly from '../widgets/usage-weekly'
import w_usage_monthly from '../widgets/usage-monthly'
import w_cc_whoami from '../widgets/cc-whoami'
import w_peak_pricing from '../widgets/peak-pricing'
import w_sys_cpu from '../widgets/sys-cpu'
import w_cc_usage from '../widgets/cc-usage'
import w_sys_gpu from '../widgets/sys-gpu'
import w_cc_credits from '../widgets/cc-credits'
import w_sys_rings from '../widgets/sys-rings'
import w_cc_windows from '../widgets/cc-windows'
import w_sys_board from '../widgets/sys-board'
import w_cc_subscription from '../widgets/cc-subscription'
import w_sys_gpu_line from '../widgets/sys-gpu-line'
import w_cc_window_5h from '../widgets/cc-window-5h'
import w_cc_window_weekly from '../widgets/cc-window-weekly'
import w_cc_window_monthly from '../widgets/cc-window-monthly'

/** Every discovered widget, in manifest display order (then by id). */
export const WIDGETS: import('./lib/contract').Widget[] = [
  w_counts,
  w_llm,
  w_tool,
  w_ttft,
  w_tps,
  w_cache,
  w_tokens,
  w_context,
  w_context_water,
  w_task,
  w_trajectory,
  w_quote,
  w_heatmap,
  w_heatmap_bars,
  w_quota_manage,
  w_usage_bars,
  w_usage_rings,
  w_usage_rolling,
  w_usage_weekly,
  w_usage_monthly,
  w_cc_whoami,
  w_peak_pricing,
  w_sys_cpu,
  w_cc_usage,
  w_sys_gpu,
  w_cc_credits,
  w_sys_rings,
  w_cc_windows,
  w_sys_board,
  w_cc_subscription,
  w_sys_gpu_line,
  w_cc_window_5h,
  w_cc_window_weekly,
  w_cc_window_monthly,
]

/** All widget ids, in registry order. */
export const ALL_IDS: string[] = [
  'counts',
  'llm',
  'tool',
  'ttft',
  'tps',
  'cache',
  'tokens',
  'context',
  'context-water',
  'task',
  'trajectory',
  'quote',
  'heatmap',
  'heatmap-bars',
  'quota-manage',
  'usage-bars',
  'usage-rings',
  'usage-rolling',
  'usage-weekly',
  'usage-monthly',
  'cc-whoami',
  'peak-pricing',
  'sys-cpu',
  'cc-usage',
  'sys-gpu',
  'cc-credits',
  'sys-rings',
  'cc-windows',
  'sys-board',
  'cc-subscription',
  'sys-gpu-line',
  'cc-window-5h',
  'cc-window-weekly',
  'cc-window-monthly',
]

/** Every valid instance key (each widget at each of its supported sizes). */
export const ALL_INSTANCES: string[] = [
  `counts@2x2`,
  `llm@2x2`,
  `tool@2x2`,
  `ttft@2x2`,
  `tps@2x2`,
  `cache@2x2`,
  `tokens@2x2`,
  `context@2x2`,
  `context-water@2x2`,
  `context-water@2x4`,
  `task@2x2`,
  `trajectory@2x2`,
  `quote@2x2`,
  `heatmap@2x2`,
  `heatmap@2x4`,
  `heatmap-bars@2x2`,
  `quota-manage@2x2`,
  `usage-bars@2x2`,
  `usage-rings@2x2`,
  `usage-rolling@2x2`,
  `usage-weekly@2x2`,
  `usage-monthly@2x2`,
  `cc-whoami@2x2`,
  `peak-pricing@2x2`,
  `sys-cpu@2x2`,
  `cc-usage@2x2`,
  `sys-gpu@2x2`,
  `cc-credits@2x2`,
  `sys-rings@2x2`,
  `cc-windows@2x2`,
  `sys-board@2x4`,
  `cc-subscription@2x2`,
  `sys-gpu-line@2x2`,
  `cc-window-5h@2x2`,
  `cc-window-weekly@2x2`,
  `cc-window-monthly@2x2`,
]

/** The stats-line family (fresh installs pre-load ONLY these). */
export const STATS_WIDGET_IDS: string[] = [
  'counts',
  'llm',
  'tool',
  'ttft',
  'tps',
  'cache',
  'tokens',
]

/** The default installed set: the stats-line family at 2×2. */
export const DEFAULT_INSTALLED: string[] = [
  `counts@2x2`,
  `llm@2x2`,
  `tool@2x2`,
  `ttft@2x2`,
  `tps@2x2`,
  `cache@2x2`,
  `tokens@2x2`,
]

/** Merged per-widget dictionaries (family-shared + every unit's locale).
 *  Registered with the locale service at apply() time. */
export const WIDGET_LOCALES: { zh: Record<string, string>; en: Record<string, string> } = {
  zh: {
    "badge.opencode": "OpenCode Go 用量配额",
    "usage.title": "OpenCode 用量",
    "usage.totalKey": "总 Key",
    "usage.cycleHint": "单击循环：{chain}",
    "usage.resets": "重置 {date}",
    "usage.rolling": "滚动",
    "usage.week": "周",
    "usage.month": "月",
    "badge.commandcode": "Command Code 账户用量",
    "group.commandcode": "Command Code",
    "cc.notConfigured": "未配置 COMMANDCODE_API_KEY（host 自动读取环境变量 / 凭据，无需手动填写）",
    "cc.unconfigured": "未配置 COMMANDCODE_API_KEY — host 自动读取环境变量 / $DSH_HOME/.credentials.yaml / .env，重启后自动生效",
    "cc.unloaded": "dsh web 未重启，等待 host 路由加载（重启后自动刷新）",
    "cc.unavailable": "Command Code 服务暂不可用",
    "cc.account": "账户",
    "cc.tokens": "tokens",
    "cc.requests": "请求",
    "cc.successRate": "成功率",
    "cc.spend": "消费",
    "cc.credits": "credits",
    "cc.free": "免费",
    "cc.purchased": "购买",
    "cc.fiveHour": "5h",
    "cc.weekly": "周",
    "cc.periodEnd": "账期至",
    "cc.title": "Command Code",
    "cc.roleUsage": "用量",
    "cc.roleCredits": "额度",
    "cc.roleWindow": "窗口",
    "cc.rolePlan": "套餐",
    "cc.roleAccount": "账户",
    "cc.win5h": "5h 窗口",
    "cc.winWeekly": "周窗口",
    "cc.winMonthly": "月窗口",
    "cc.resets": "重置",
    "cc.cancelAtEnd": "到期不续订",
    "sysinfo.cpu": "CPU",
    "sysinfo.gpu": "GPU",
    "sysinfo.mem": "内存",
    "sysinfo.vram": "显存",
    "sysinfo.memSub": "内存 {used} / {total}",
    "sysinfo.interval": "刷新间隔",
    "sysinfo.intervalCustom": "自定义",
    "sysinfo.intervalCustomValue": "自定义间隔（秒）",
    "sysinfo.noGpu": "未检测到 NVIDIA GPU",
    "sysinfo.waiting": "等待设备数据…",
    "sysinfo.bigMetric": "大数值显示",
    "sysinfo.bigVram": "显存 (GB)",
    "sysinfo.bigTemp": "温度 (°C)",
    "sysinfo.bigUtil": "利用率 (%)",
    "sysinfo.bigMem": "内存 (GB)",
    "sysinfo.bigHint": "点击切换大数值：{chain}",
    "sysinfo.points": "折线采样数",
    "widget.counts.name": "轮次·步数",
    "widget.counts.desc": "本轮会话的轮次与步骤计数",
    "card.counts.value": "{turns}轮 {steps}步",
    "widget.llm.name": "LLM 时长",
    "widget.llm.desc": "模型推理累计耗时",
    "widget.tool.name": "工具调用",
    "widget.tool.desc": "工具调用累计耗时",
    "widget.ttft.name": "首 token 平均",
    "widget.ttft.desc": "平均首 token 延迟",
    "widget.tps.name": "速率",
    "widget.tps.desc": "解码吞吐速度",
    "widget.cache.name": "缓存命中",
    "widget.cache.desc": "输入缓存的命中比例",
    "widget.tokens.name": "Tokens",
    "widget.tokens.desc": "输入与输出 token 计数",
    "widget.context.name": "一键压缩",
    "widget.context.desc": "上下文占用百分比，右上按钮两次点击执行压缩",
    "card.context.title": "一键压缩",
    "card.context.waiting": "等待上下文数据",
    "card.context.compact": "压缩",
    "card.context.confirm": "确认",
    "widget.context-water.name": "上下文水位",
    "widget.context-water.desc": "上下文系统/工具/消息占比分段条",
    "card.contextWater.title": "上下文已用",
    "card.contextWater.system": "系统提示词",
    "card.contextWater.tools": "工具",
    "card.contextWater.messages": "对话消息",
    "widget.task.name": "任务",
    "widget.task.desc": "当前任务的进行中/已完成/待办计数",
    "card.task.done": "{n} 已完成",
    "card.task.none": "暂无任务",
    "card.task.sub": "{doing} 进行中 · {pending} 待办",
    "widget.trajectory.name": "对话轨迹",
    "widget.trajectory.desc": "官方「轨迹」三色泳道的卡片版：输入 / 模型 / 工具 每次触发一根色条，随模型调用工具实时右移滚动",
    "card.trajectory.legend": "输入 {input}  模型 {model}  工具 {tool}",
    "card.trajectory.input": "输入",
    "card.trajectory.model": "模型",
    "card.trajectory.tool": "工具",
    "config.laneSizing": "泳道宽度",
    "config.laneSizing.time": "按时长",
    "config.laneSizing.equal": "等宽",
    "widget.quote.name": "今日寄语",
    "widget.quote.desc": "显示你自定义的一句话（未填写文本时不显示内容）",
    "card.quote.title": "今日寄语",
    "config.quoteText": "寄语内容",
    "config.showTitle": "显示标题",
    "config.align": "水平对齐",
    "config.valign": "垂直位置",
    "config.wrap": "允许换行",
    "quote.previewPlaceholder": "（填写寄语内容后显示）",
    "widget.heatmap.name": "用量热度图",
    "widget.heatmap.desc": "每日 Token 用量热度图（自记账）。2×2 显示近 3 个月日历，2×4 显示近半年全部用量点；大小可在市场左右切换",
    "card.heatmap.title": "Token 用量",
    "config.monthMode": "窗口对齐方式",
    "config.monthMode.rolling": "滚动(今天最右)",
    "config.monthMode.quarter": "季度对齐",
    "config.timeZone": "记账时区",
    "config.timeZone.beijing": "北京 (UTC+8)",
    "config.timeZone.local": "跟随系统",
    "widget.heatmap-bars.name": "用量柱状图",
    "widget.heatmap-bars.desc": "最近 7 天 Token 用量的垂直柱状图，柱区高度与日历图一致",
    "config.monthMode.rolling7": "滚动(最近7天)",
    "config.monthMode.weekly": "每周对齐",
    "widget.quota-manage.name": "额度管理",
    "widget.quota-manage.desc": "按账期趋势预测月末用量百分比，并给出今日 token 用量与今日推荐用量",
    "widget.quota-manage.periodEnd": "账期 {m}-{d}",
    "widget.quota-manage.used": "今日用量",
    "widget.quota-manage.recommend": "今日推荐",
    "widget.quota-manage.insufficient": "数据不足",
    "widget.quota-manage.simToggle": "超额状态",
    "widget.usage-bars.name": "用量对比",
    "widget.usage-bars.desc": "OpenCode 滚动/周/月三窗口用量柱状图",
    "widget.usage-rings.name": "用量环图",
    "widget.usage-rings.desc": "OpenCode 滚动/周/月三窗口用量环形图",
    "widget.usage-rolling.name": "滚动用量",
    "widget.usage-rolling.desc": "OpenCode Go 滚动窗口用量配额",
    "widget.usage-weekly.name": "每周用量",
    "widget.usage-weekly.desc": "OpenCode Go 每周用量配额",
    "widget.usage-monthly.name": "每月用量",
    "widget.usage-monthly.desc": "OpenCode Go 每月用量配额",
    "widget.cc-whoami.name": "账户",
    "widget.cc-whoami.desc": "当前 Command Code 账户身份（用户名 / 邮箱 / 组织）",
    "widget.peak-pricing.name": "峰谷定价",
    "widget.peak-pricing.desc": "DeepSeek V4 峰谷定价：当前是否处于高峰时段（北京时间，工作日 09:00–12:00 与 14:00–18:00 为高峰）",
    "card.peak.title": "峰谷定价",
    "card.peak.window1": "上午 09:00–12:00",
    "card.peak.window2": "下午 14:00–18:00",
    "sim.peak": "高峰/低峰",
    "widget.sys-cpu.name": "CPU 状态",
    "widget.sys-cpu.desc": "本机 CPU 利用率与内存占用",
    "widget.cc-usage.name": "用量",
    "widget.cc-usage.desc": "账期内的请求数、成功率、Token 与消费摘要",
    "widget.sys-gpu.name": "GPU 状态",
    "widget.sys-gpu.desc": "本机 NVIDIA GPU 显存、利用率与温度",
    "widget.cc-credits.name": "额度",
    "widget.cc-credits.desc": "Credits 余额与 5h / 周额度窗口用量",
    "widget.sys-rings.name": "CPU·GPU 环图",
    "widget.sys-rings.desc": "CPU / GPU 利用率双环形图",
    "widget.cc-windows.name": "窗口",
    "widget.cc-windows.desc": "5h / 周 / 月 三窗口用量环图",
    "widget.sys-board.name": "系统监控",
    "widget.sys-board.desc": "CPU/内存/GPU 显存与利用率全指标环形看板",
    "widget.cc-subscription.name": "套餐",
    "widget.cc-subscription.desc": "当前套餐、状态与账期结束时间",
    "widget.sys-gpu-line.name": "GPU 利用率",
    "widget.sys-gpu-line.desc": "GPU 利用率折线（最近约 20 分钟）",
    "widget.cc-window-5h.name": "5h 窗口",
    "widget.cc-window-5h.desc": "5 小时额度窗口用量百分比与重置时间",
    "widget.cc-window-weekly.name": "周窗口",
    "widget.cc-window-weekly.desc": "周额度窗口用量百分比与重置时间",
    "widget.cc-window-monthly.name": "月窗口",
    "widget.cc-window-monthly.desc": "账期月额度用量百分比（已用 / 已用+剩余）与账期结束时间",
  },
  en: {
    "badge.opencode": "OpenCode Go Usage Quota",
    "usage.title": "OpenCode Usage",
    "usage.totalKey": "All Keys",
    "usage.cycleHint": "Click to cycle: {chain}",
    "usage.resets": "Resets {date}",
    "usage.rolling": "Rolling",
    "usage.week": "Week",
    "usage.month": "Month",
    "badge.commandcode": "Command Code Account Usage",
    "group.commandcode": "Command Code",
    "cc.notConfigured": "COMMANDCODE_API_KEY not configured (host auto-reads env / credentials, no manual entry)",
    "cc.unconfigured": "COMMANDCODE_API_KEY not configured — the host auto-reads env / $DSH_HOME/.credentials.yaml / .env; effective after a restart",
    "cc.unloaded": "dsh web not restarted — waiting for the host route (auto-refresh after restart)",
    "cc.unavailable": "Command Code service unavailable",
    "cc.account": "Account",
    "cc.tokens": "tokens",
    "cc.requests": "requests",
    "cc.successRate": "success",
    "cc.spend": "Spend",
    "cc.credits": "credits",
    "cc.free": "Free",
    "cc.purchased": "Purchased",
    "cc.fiveHour": "5h",
    "cc.weekly": "Week",
    "cc.periodEnd": "Period ends",
    "cc.title": "Command Code",
    "cc.roleUsage": "Usage",
    "cc.roleCredits": "Credits",
    "cc.roleWindow": "Windows",
    "cc.rolePlan": "Plan",
    "cc.roleAccount": "Account",
    "cc.win5h": "5h window",
    "cc.winWeekly": "Weekly window",
    "cc.winMonthly": "Monthly window",
    "cc.resets": "Resets",
    "cc.cancelAtEnd": "Cancels at period end",
    "sysinfo.cpu": "CPU",
    "sysinfo.gpu": "GPU",
    "sysinfo.mem": "Memory",
    "sysinfo.vram": "VRAM",
    "sysinfo.memSub": "Mem {used} / {total}",
    "sysinfo.interval": "Refresh interval",
    "sysinfo.intervalCustom": "Custom",
    "sysinfo.intervalCustomValue": "Custom interval (s)",
    "sysinfo.noGpu": "No NVIDIA GPU detected",
    "sysinfo.waiting": "Waiting for device data…",
    "sysinfo.bigMetric": "Big figure",
    "sysinfo.bigVram": "VRAM (GB)",
    "sysinfo.bigTemp": "Temp (°C)",
    "sysinfo.bigUtil": "Utilization (%)",
    "sysinfo.bigMem": "Memory (GB)",
    "sysinfo.bigHint": "Click to cycle the big figure: {chain}",
    "sysinfo.points": "Sparkline samples",
    "widget.counts.name": "Turns · Steps",
    "widget.counts.desc": "Turns and steps of the current session",
    "card.counts.value": "{turns} turns · {steps} steps",
    "widget.llm.name": "LLM Time",
    "widget.llm.desc": "Cumulative model inference time",
    "widget.tool.name": "Tool Calls",
    "widget.tool.desc": "Cumulative tool call time",
    "widget.ttft.name": "Avg TTFT",
    "widget.ttft.desc": "Average first-token latency",
    "widget.tps.name": "Rate",
    "widget.tps.desc": "Decode throughput speed",
    "widget.cache.name": "Cache Hit",
    "widget.cache.desc": "Input cache hit ratio",
    "widget.tokens.name": "Tokens",
    "widget.tokens.desc": "Input & output token counts",
    "widget.context.name": "Compact",
    "widget.context.desc": "Context usage percent; top-right button compacts after two taps",
    "card.context.title": "Compact",
    "card.context.waiting": "Waiting for context data",
    "card.context.compact": "Compact",
    "card.context.confirm": "Confirm",
    "widget.context-water.name": "Context Level",
    "widget.context-water.desc": "System/tools/messages share as a segmented bar",
    "card.contextWater.title": "Context Used",
    "card.contextWater.system": "System prompt",
    "card.contextWater.tools": "Tools",
    "card.contextWater.messages": "Messages",
    "widget.task.name": "Tasks",
    "widget.task.desc": "Counts of in-progress / completed / pending tasks",
    "card.task.done": "{n} done",
    "card.task.none": "No tasks",
    "card.task.sub": "{doing} in progress · {pending} pending",
    "widget.trajectory.name": "Trajectory",
    "widget.trajectory.desc": "The official 轨迹 rail as a card: one colored bar per input / model / tool beat, rolling right as the model keeps calling tools",
    "card.trajectory.legend": "In {input}  Model {model}  Tool {tool}",
    "card.trajectory.input": "Input",
    "card.trajectory.model": "Model",
    "card.trajectory.tool": "Tool",
    "config.laneSizing": "Lane Width",
    "config.laneSizing.time": "By duration",
    "config.laneSizing.equal": "Equal width",
    "widget.quote.name": "Daily Quote",
    "widget.quote.desc": "Shows a custom sentence you typed (hidden while empty)",
    "card.quote.title": "Daily Quote",
    "config.quoteText": "Quote Text",
    "config.showTitle": "Show Title",
    "config.align": "Horizontal Align",
    "config.valign": "Vertical Position",
    "config.wrap": "Allow Wrap",
    "quote.previewPlaceholder": "(shown after you type a quote)",
    "widget.heatmap.name": "Token Heatmap",
    "widget.heatmap.desc": "Daily token usage heatmap (self-accounted). 2×2 shows a ~3-month calendar, 2×4 the ~half-year history; switch size in the market",
    "card.heatmap.title": "Token Usage",
    "config.monthMode": "Window Alignment",
    "config.monthMode.rolling": "Rolling (today right)",
    "config.monthMode.quarter": "Quarter-aligned",
    "config.timeZone": "Accounting Timezone",
    "config.timeZone.beijing": "Beijing (UTC+8)",
    "config.timeZone.local": "Follow system",
    "widget.heatmap-bars.name": "Token Bars",
    "widget.heatmap-bars.desc": "Vertical bars of the last 7 days of token usage; same height as the calendar view",
    "config.monthMode.rolling7": "Rolling (last 7 days)",
    "config.monthMode.weekly": "Weekly aligned",
    "widget.quota-manage.name": "Quota Manager",
    "widget.quota-manage.desc": "Projects the month-end usage percent from the billing period's pace, with today's tokens vs the recommended budget",
    "widget.quota-manage.periodEnd": "Ends {m}-{d}",
    "widget.quota-manage.used": "Today",
    "widget.quota-manage.recommend": "Budget",
    "widget.quota-manage.insufficient": "No data",
    "widget.quota-manage.simToggle": "Over budget",
    "widget.usage-bars.name": "Usage Bars",
    "widget.usage-bars.desc": "OpenCode rolling/weekly/monthly usage bars",
    "widget.usage-rings.name": "Usage Rings",
    "widget.usage-rings.desc": "OpenCode rolling/weekly/monthly usage rings",
    "widget.usage-rolling.name": "Rolling Usage",
    "widget.usage-rolling.desc": "OpenCode Go rolling-window usage quota",
    "widget.usage-weekly.name": "Weekly Usage",
    "widget.usage-weekly.desc": "OpenCode Go weekly usage quota",
    "widget.usage-monthly.name": "Monthly Usage",
    "widget.usage-monthly.desc": "OpenCode Go monthly usage quota",
    "widget.cc-whoami.name": "Account",
    "widget.cc-whoami.desc": "Current Command Code account identity (name / email / org)",
    "widget.peak-pricing.name": "Peak Pricing",
    "widget.peak-pricing.desc": "DeepSeek V4 peak pricing: whether now is a peak window (Beijing time, weekdays 09:00–12:00 & 14:00–18:00 are peak)",
    "card.peak.title": "Peak Pricing",
    "card.peak.window1": "Morning 09:00–12:00",
    "card.peak.window2": "Afternoon 14:00–18:00",
    "sim.peak": "Peak/Off-Peak",
    "widget.sys-cpu.name": "CPU Status",
    "widget.sys-cpu.desc": "Local CPU utilization and memory usage",
    "widget.cc-usage.name": "Usage",
    "widget.cc-usage.desc": "Requests, success rate, tokens and spend for the billing period",
    "widget.sys-gpu.name": "GPU Status",
    "widget.sys-gpu.desc": "Local NVIDIA GPU VRAM, utilization and temperature",
    "widget.cc-credits.name": "Credits",
    "widget.cc-credits.desc": "Credit balance with 5h / weekly window usage",
    "widget.sys-rings.name": "CPU · GPU Rings",
    "widget.sys-rings.desc": "CPU / GPU utilization twin rings",
    "widget.cc-windows.name": "Windows",
    "widget.cc-windows.desc": "5h / weekly / monthly usage as rings",
    "widget.sys-board.name": "System Monitor",
    "widget.sys-board.desc": "CPU / memory / GPU VRAM and utilization dashboard rings",
    "widget.cc-subscription.name": "Plan",
    "widget.cc-subscription.desc": "Current plan, status and billing period end",
    "widget.sys-gpu-line.name": "GPU Utilization",
    "widget.sys-gpu-line.desc": "GPU utilization sparkline (last ~20 min)",
    "widget.cc-window-5h.name": "5h window",
    "widget.cc-window-5h.desc": "5-hour quota window usage percent and reset time",
    "widget.cc-window-weekly.name": "Weekly window",
    "widget.cc-window-weekly.desc": "Weekly quota window usage percent and reset time",
    "widget.cc-window-monthly.name": "Monthly window",
    "widget.cc-window-monthly.desc": "Billing-period usage percent (used / used+remaining) and period end",
  },
}
